import Swiper, {Pagination, Navigation} from 'swiper';

Swiper.use([Pagination, Navigation]);

const isTouchDevice = matchMedia("(pointer: coarse)").matches;

document.addEventListener('DOMContentLoaded', () => {
	const locationSelect = document.querySelector('.main #selectLocation select');
	if (locationSelect) {
		let prevSlider = clubsSliderInit(locationSelect.value);

		locationSelect.addEventListener('change', (e) => {
			prevSlider.destroy();
			prevSlider = clubsSliderInit(e.target.value);
		})
	}

	const swiperGridRegional = new Swiper('#regional .swiper', {
		slidesPerView: 'auto',
		paginationClickable: true,
		spaceBetween: 16,
		navigation: {
			nextEl: '.slider-grid__button_next',
			prevEl: '.slider-grid__button_prev',
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			1025: {
				slidesPerView: 3,
				spaceBetween: 40,
			}
		},
	});

	const swiperGridNews = new Swiper('#newsOthers .swiper', {
		slidesPerView: 'auto',
		paginationClickable: true,
		spaceBetween: 16,
		navigation: {
			nextEl: '.slider-grid__button_next',
			prevEl: '.slider-grid__button_prev',
		},
		pagination: {
			el: '.slider-grid .swiper-pagination',
			type: 'bullets',
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			1025: {
				slidesPerView: 3,
				spaceBetween: 40,
			}
		},
	});
})

function clubsSliderInit(id) {
	const sliderWrapper = document.querySelector(`#clubs_region_slider_${id}`);
	const slider = sliderWrapper.querySelector('.swiper');
	const nextButton = sliderWrapper.querySelector('[data-slider-next]');
	const prevButton = sliderWrapper.querySelector('[data-slider-prev]');

	const swiperGrid = new Swiper(slider, {
		slidesPerView: 'auto',
		paginationClickable: true,
		spaceBetween: 16,
		navigation: {
			nextEl: nextButton,
			prevEl: prevButton,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			1025: {
				slidesPerView: 3,
				spaceBetween: 40,
			}
		},
	});

	return swiperGrid;
}
